// Third-party
import React from 'react';
import classNames from 'classnames';

// Components
import NoDataCell from './NoDataCell';
import { Tooltip } from '../tooltips';
import ComparisonItem from '@/types/comparison-item';

type Props = {
  value?: string | number;
  className?: string;
  disclaimer?: string;
  item?: ComparisonItem;
  tooltipMessage?: string;
};

const CorrelationMatrixLabelCell: React.FunctionComponent<Props> = ({ value, className, disclaimer, item, tooltipMessage }: Props) => {
  if (value == null) {
    return <NoDataCell disclaimerKey={disclaimer} item={item} />;
  }

  return (
    <div className={classNames('cell correlation-matrix-label-cell', className)}>
      <Tooltip disabled={!tooltipMessage} message={tooltipMessage}>
        <span>{value}</span>
      </Tooltip>
    </div>
  );
};

export default CorrelationMatrixLabelCell;
